export enum DayOfWeek {
  Sunday = 1,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday
}

export enum EmployeeType
{
  WTwo = 1,
  OneZeroNineNine = 2
}

export enum PayrollType
{
  EndOfDay = 1,
  Weekly = 2,
  Biweekly = 3,
  DirectDeposit = 4,
  Other = 5
}

export enum ShiftFormPostType
{
  All,
  FavoritesOnly
}

export enum ShiftFormChannelType
{
  SingleColumn = 1,
  DoubleColumn
}

export enum VacancyStatus
{
  Active = 1,
  Deleted,
  Filled
}

export enum ErrorType {
  Misc,
  Confirmation,
  Credentials
}

export abstract class Roles {
  static DentalStaff = "DentalStaff";
  static OfficeUser = "OfficeUser";
  static PracticeUser = "PracticeUser";
  static CustomerSupport = "CustomerSupport";
}

export enum WizardStep {
  Welcome = 1,
  Information,
  Schedulers,
  Hours,
  Rates,
  Payrolls,
  Complete
}